import { APP_NAME } from "@/lib/constants";

export function LoadingScreen({ label = "Loading your workspace…" }: { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex h-full min-h-screen w-full flex-col items-center justify-center gap-4 bg-background"
    >
      <div className="flex items-center gap-2.5">
        <span className="h-2 w-2 animate-pulse rounded-full bg-primary" />
        <span className="font-display text-base font-semibold tracking-tight">{APP_NAME}</span>
      </div>
      <p className="text-sm text-muted-foreground">{label}</p>
    </div>
  );
}
